/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import LockOpenIcon from "@mui/icons-material/LockOpen";

const UserUnlockModel = ({ open, user, isSubmit, userUnlock, onClose }) => {
  return (
    <Dialog open={open} PaperProps={{ style: { borderRadius: "10px" } }}>
      <DialogTitle id="alert-dialog-title">
        Are you sure you want to Unlock {user}?
      </DialogTitle>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error">
          Cancel
        </Button>
        <LoadingButton
          loading={isSubmit}
          loadingPosition="start"
          startIcon={<LockOpenIcon />}
          variant="contained"
          color="success"
          onClick={userUnlock}>
          Unlock
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default UserUnlockModel;
